// src/ui/sugerirChave.js
// Modal global para SUGERIR uma nova chave (botao flutuante). So CRIAR; cancelar uma
// chave existente continua na tela de Chaves (precisa escolher a chave da lista).
import { el } from '../lib/dom.js';
import { abrirModal } from './modal.js';
import { toast } from '../lib/toast.js';
import { sugerirCriarChave } from '../domain/sugestoes.js';

export function abrirSugerirNovaChave() {
  const descricao = el('input', { type: 'text', placeholder: 'Setor / sala da chave (ex.: Almoxarifado Central)' });
  const motivo = el('input', { type: 'text', placeholder: 'Por que esta chave precisa existir?' });
  abrirModal({
    titulo: 'Sugerir nova chave',
    corpo: [
      el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Sua sugestão vai para o gestor aprovar. O número é gerado pelo sistema.' }),
      el('div', { class: 'campo' }, [el('label', { text: 'Descrição (setor/sala) *' }), descricao]),
      el('div', { class: 'campo' }, [el('label', { text: 'Motivo *' }), motivo]),
    ],
    acoes: [
      { rotulo: 'Cancelar', classe: 'btn' },
      { rotulo: 'Enviar sugestão', classe: 'btn btn--primario', onClick: async () => {
        if (!descricao.value.trim()) { toast('Descreva a chave (setor/sala).', 'erro'); return false; }
        if (!motivo.value.trim()) { toast('Informe o motivo.', 'erro'); return false; }
        const { erro } = await sugerirCriarChave(descricao.value.trim(), motivo.value.trim());
        if (erro) { toast('Não foi possível enviar: ' + erro, 'erro'); return false; }
        toast('Sugestão enviada ao gestor.', 'sucesso');
        return true;
      } },
    ],
  });
}